'use client';

import { TableColumnText, tableColumnTextTag } from '@ni/nimble-components/dist/esm/table-column/text';
import { wrap } from '../../utilities/react-wrapper';

export { tableColumnTextTag };
export { type TableColumnText };
export const NimbleTableColumnText = wrap(TableColumnText);
